export default {
  border: {
    style: 'solid',
    thickness: '0.03125rem',
  },
};
